export const companyDetailsTranslations = {
  header: {
    hpMemberUnderAmplifySince: 'company_details-header-hp_member_under_amplify_since',
  },
  flags: {
    frequent: 'company_details-flags-frequent',
    nonFrequent: 'company_details-flags-non_frequent',
    agentRanking50: 'company_details-flags-agent_ranking_50',
    agentRanking100: 'company_details-flags-agent_ranking_100',
    agentRanking200: 'company_details-flags-agent_ranking_200',
    contractStatus: 'company_details-flags-contract_status',
    orgStatus: 'company_details-flags-opg_status',
    amplifyProgram: 'company_details-flags-amplify_program',
  },
  details: {
    hpMemberSince: 'company_details-details-hp_member_since',
    hpMemberUnderAmplifySince: 'company_details-details-hp_member_under_amplify_since',
    hpMemberUnderBusinessSince: 'company_details-details-hp_member_under_business_since',
    hpMemberUnderDistributorSince: 'company_details-details-hp_member_under_distributor_since',
    hpInAgrimentWithHP: 'company_details-details-hp_in_agriment_with_hp',
    lnrStatus: 'company_details-details-lnr_status',
    pricingType: 'company_details-details-pricing_type',
    market: 'company_details-details-market',
    organization: 'company_details-details-organization',
    taxId: 'company_details-details-tax_id',
    parentPartnerId: 'company_details-details-parent_partner_id',
    partnerId: 'company_details-details-partner_id',
    locationId: 'company_details-details-location_id',
    reporterId: 'company_details-details-reporter_id',
    storeNumber: 'company_details-details-store_number',
  },
  statuses: {
    basic: 'company_details-statuses-basic',
    legal: 'company_details-statuses-legal',
    program: 'company_details-statuses-program',
    accreditation: 'company_details-statuses-accreditation',
  },
  actions: {
    phoneCall: 'company_details-actions-phone_call',
    website: 'company_details-actions-website',
    editPartner: 'company_details-actions-edit_partner',
    partnerStatusButton: 'company_details-actions-partner_status_button',
  },
  partnerStatusModal: {
    partnerStatus: 'company_details-partner_status_modal-partner_status',
    amplifyImpactSummary: 'company_details-partner_status_modal-amplify_impact_summary',
  },
  other: {
    showMore: 'company_details-other-show_more',
  },
}
